import React, { useEffect, useState } from 'react';
import './EventsPage.css';
import api from '../api';

export default function EventsPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/events/upcoming')
      .then((res) => {
        setEvents(Array.isArray(res.data) ? res.data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="events-page">Loading event...</div>;
  if (events.length === 0) return <div className="events-page">No upcoming events</div>;

  const formatStartDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return '';
    const date = new Date(dateTimeStr);
    const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.toLocaleDateString('en-US', { day: 'numeric' });
    const year = date.toLocaleDateString('en-US', { year: 'numeric' });
    const datePart = `${weekday} ${month} ${day}, ${year}`;
    const timePart = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
    return `${datePart} at ${timePart}`;
  };

  return (
    <div className="events-page">
      <div className="events-panel">
        <header className="events-heading">
          <p className="events-eyebrow">Vedanta Center of Charlotte</p>
          <h1>Upcoming Events</h1>
          <p>Gather with us for talks, celebrations, and community events.</p>
        </header>

        <div className="events-list">
          {events.map((event) => {
            const dateStr = formatStartDateTime(event.date_time);
            const endTimeStr = event.end_time
              ? new Date(event.end_time).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
              : '';
            const registrationUrl = event.registration_link || (event.id ? `/register/${event.id}` : null);

            return (
              <article className={`event-card${event.image_url ? '' : ' event-card-no-image'}${event.is_cancelled ? ' event-card-cancelled' : ''}`} key={event.id}>
                {event.image_url && (
                  <img className="events-speaker" src={event.image_url} alt={event.event_name} />
                )}
                <div className="event-card-content">
                  <div className="event-card-title">
                    <h2>{event.event_name}</h2>
                    {event.is_cancelled && <span className="event-status">Cancelled</span>}
                  </div>
                  <p className="event-date"><strong>When:</strong> {dateStr}{endTimeStr && ` - ${endTimeStr}`}</p>
                  <p className="event-address"><strong>Where:</strong> {event.address}</p>
                  {event.is_cancelled && event.cancelled_reason && (
                    <p className="event-cancellation">This event has been cancelled: {event.cancelled_reason}</p>
                  )}
                  {!event.is_cancelled && registrationUrl && (
                    <a className="event-register" href={registrationUrl} target="_blank" rel="noopener noreferrer">
                      Register for this event <span aria-hidden="true">→</span>
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </div>

        <section className="events-contact" aria-labelledby="events-contact-heading">
          <p className="events-eyebrow">Stay connected</p>
          <h2 id="events-contact-heading">Contact us for more details</h2>
          <div className="contact-links">
            <a href="https://www.facebook.com/groups/1150517765574184" target="_blank" rel="noopener noreferrer">
              Facebook: Vedanta Center Charlotte
            </a>
            <a href="mailto:info@vedantacentercharlotte.org">Email: info@vedantacentercharlotte.org</a>
            <p>Phone: Banashri 980-248-8370, Kamalesh 704-449-5609, Krishna 832-691-9247</p>
          </div>
        </section>
      </div>
    </div>
  );
}
